import { AaOtpVerifyResp } from 'app/bff/models/aa/aaOtpVerify';
import { AaSigninResp } from 'app/bff/models/aa/aaSignin';
import { MbGetinfoReq, MbGetinfoResp } from 'app/bff/models/mb/mbGetinfo';
import { MbSigninResp } from 'app/bff/models/mb/mbSignin';
import { CommonState, CommonActions, COMMON__INIT_FETCH_COMMON_DATA, COMMON__INIT_FETCH_COMMON_DATA_DONE, COMMON__SAVE_MEMBER_AUTHORIZATION, COMMON__FETCH_MEMBER_PROFILE, COMMON__FETCH_MEMBER_PROFILE_DONE, COMMON__RESET_MEMBER_CACHE } from './types';

/**
 * @description 初始取得系統共用選項資料 (Action)
 */
export const initFetchCommonDataAction = (): CommonActions => ({
  type: COMMON__INIT_FETCH_COMMON_DATA
});

/**
 * @description 初始取得系統共用選項資料 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const initFetchCommonDataDoneAction = (response: CommonState): CommonActions => ({
  type: COMMON__INIT_FETCH_COMMON_DATA_DONE,
  payload: { response }
});

/**
 * @description 緩存「會員主檔」和「Access Token」 (Action)
 * @param authorization 會員登入授權
 */
export const saveMemberAuthorizationAction = (authorization: AaOtpVerifyResp | AaSigninResp | MbSigninResp): CommonActions => ({
  type: COMMON__SAVE_MEMBER_AUTHORIZATION,
  payload: { authorization }
});

/**
 * @description 取得會員資料 (Action)
 * @param args 請求所需的參數
 */
export const fetchMemberProfileAction = (args: MbGetinfoReq): CommonActions => ({
  type: COMMON__FETCH_MEMBER_PROFILE,
  payload: { args }
});

/**
 * @description 取得會員資料 完成 (Action)
 * @param response 請求回傳的 Response
 */
export const fetchMemberProfileDoneAction = (response: MbGetinfoResp): CommonActions => ({
  type: COMMON__FETCH_MEMBER_PROFILE_DONE,
  payload: { response }
});

/**
 * @description 重置會員相關資料緩存 (Action)
 */
export const resetMemberCacheAction = (): CommonActions => ({
  type: COMMON__RESET_MEMBER_CACHE
});
